import Navbar from "./components/navbar/Navbar";
import MainContainer from "./components/MainContainer";
import HomePage from "./pages/HomePage";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AddEditActivity from "./pages/AddEditActivity";
import HandleActivities from "./pages/HandleActivities";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import RegisterLoginPage from "./pages/RegisterLoginPage";
import { getLoading, getLogged, getUnlogged } from "./redux/userSlice";
import ProfilePage from "./pages/ProfilePage";
import ResetPasswordRequest from "./pages/ResetPasswordRequest";
import SetNewPassword from "./pages/SetNewPassword";
import ActivityDetails from "./pages/ActivityDetails";
import ProtectedRoute from "./components/ProtectedRoute";
import AllActivities from "./pages/AllActivities";
import Footer from "./components/Footer";
import HandleShop from "./pages/HandleShop";
import AddEditProduct from "./pages/AddEditProduct";
import Shop from "./pages/Shop";
import ProductDetails from "./pages/ProductDetails";
import MapPage from "./pages/MapPage";
import Test from "./components/test";
import ChooseCategory from "./pages/ChooseCategory";
import PhotosGallery from "./pages/PhotosGallery";
import AddEditCompany from "./pages/AddEditCompany";
import HandleCompanies from "./pages/HandleCompanies";
import CompanyDetails from "./pages/CompanyDetails";
import SendRequest from "./pages/booking/SendRequest";
import CompanyHandleRequest from "./pages/booking/CompanyHandleRequest";
import UserPurchaseResult from "./pages/booking/UserPurchaseResult";
import './i18n';
import HandleActivityTranslation from "./pages/HandleActivityTranslation.jsx";
import WhoWeAre from "./pages/WhoWeAre.jsx";
import Contacts from "./pages/Contacts.jsx";
import BaseBar from "./components/navigationBar/BaseBar.jsx";
import ScrollPlaceholder from "./components/ScrollPlaceholder.jsx";
import PartnerPage from "./pages/PartnerPage.jsx";
import UserPurchaseDataCheck from "./components/booking/UserPurchaseDataCheck.js";
import SetUserData from "./pages/SetUserData.jsx";
import UserTermsAndConditions from "./pages/UserTermsAndConditions.jsx";
import ProductPurchased from "./pages/shopOrders/ProductPurchased.jsx";
import SetShippingData from "./pages/SetShippingData.jsx";
import UserShippingDataCheck from "./components/shopOrders/UserShippingDataCheck.js";
import ConfirmOrderRequest from "./pages/shopOrders/ConfirmOrderRequest.jsx";
import ScrollToTop from "./components/ScrollToTop.js";
import PwaModal from "./components/PwaModal.jsx";
import Cart from "./pages/Cart.jsx";
import { updateCartFromLocalStorage } from "./redux/cartSlice.js";
import CheckoutPage from "./pages/shopOrders/CheckoutPage.jsx";
import PartnerUserTermsAndConditions from "./pages/PartnerTermsAndConditions.jsx";
import ImageDisclaimer from "./pages/ImageDisclaimer.jsx";
import DownloadTutorial from "./pages/DownloadTutorial.jsx";
import { FavouritesPage } from "./pages/FavouritesPage";

function App() {

  // Check login session
  const token = localStorage.getItem('ticino-wild-token');
  useEffect(() => {
    if (token) {
      sendRefresh();
    }
  }, [token])

  // Refresh token, se valido e non scaduto
  const { isLogged, level } = useSelector(state => state.user);
  const dispatch = useDispatch();
  const sendRefresh = async () => {
    try {
      getLoading(true)
      const url = `${process.env.REACT_APP_SERVER_BASE_URL}/users/refresh-token`;
      const headers = { 'Content-Type': 'application/json' };
      const options = { method: 'POST', headers, body: JSON.stringify({ token }) }
      const response = await fetch(url, options);
      if (response.ok) {
        const result = await response.json();
        localStorage.setItem('ticino-wild-token', result.payload.token);
        dispatch(getLogged(result.payload));
      } else {
        const error = await response.json();
        dispatch(getUnlogged());
      }
    } catch (error) {
      dispatch(getUnlogged());
    }
  }

  // Gestisco la disattivazione dello scroll (SearchBar aperta)
  const { isActive } = useSelector(state => state.scroll);
  useEffect(() => {
    if (!isActive) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
    // Cleanup
    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, [isActive]);

  // CARRELLO
  // Verifico che sia presente cart in localStorage
  useEffect(() => {
    const storedCart = localStorage.getItem('ticino-wild-cart');
    if (storedCart) dispatch(updateCartFromLocalStorage(JSON.parse(storedCart)));
  }, [dispatch]);

  // Gestisco la modale di richiesta installazione PWA
  // Verifico che la Pwa sia installabile e se l'utente ha già settato la risposta
  const [pwaReplied, setPwaReplied] = useState(null);
  const [isInstallable, setIsInstallable] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);

  // Questo stato impedisce la visualizzazione della modale della pwa al caricamento della pagina applicando un ritardo
  const [isDelayDone, setIsDelayDone] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setIsDelayDone(true)
    }, 1000)
  }, [])
  useEffect(() => {
    // Verifico la risposta dell'utente
    const isReplied = localStorage.getItem('ticino-wild-pwaReplied');
    if (isReplied) {
      if (isReplied === 'yes') {
        setPwaReplied('yes');
        return;
      } else if (isReplied === 'no') {
        setPwaReplied('no');
        return;
      } else {
        localStorage.removeItem('ticino-wild-pwaReplied');
        setPwaReplied(null)
      }
    }
    // Ascolto l'evento beforeinstallprompt
    const handleBeforeInstallPrompt = (event) => {
      event.preventDefault(); // Previene il comportamento predefinito
      setDeferredPrompt(event); // Salvo l'evento di installazione PWA per utilizzarlo in un secondo momento
      setIsInstallable(true); // Indica che è installabile
    };
    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    }
  }, [])

  const handleInstallClick = async (choice) => {
    if (choice === 'yes') {
      setPwaReplied('yes');
      localStorage.setItem('ticino-wild-pwaReplied', 'yes');
      if (deferredPrompt) {
        deferredPrompt.prompt(); // Mostra il prompt dell'installazione
        const promptResult = await deferredPrompt.userChoice; // Aspetta la scelta dell'utente
        if (promptResult.outcome === "accepted") {
          console.log("PWA installata con successo!");
        } else {
          console.log("Installazione PWA annullata.");
        }
        setDeferredPrompt(null); // Reset dell'evento
        setIsInstallable(false);
      }
    } else {
      setPwaReplied('no');
      localStorage.setItem('ticino-wild-pwaReplied', 'no');
    }
  }

  return (
    <Router>
      <MainContainer>
        <Navbar />
        <ScrollPlaceholder />
        <ScrollToTop />
        {!pwaReplied && isDelayDone && <PwaModal sendBackReply={handleInstallClick} />}
        <Routes>
          {/* Aggiungere uno scrollToTop automatico per ogni cambio di rotta */}
          <Route exact path="/" element={<HomePage />} /> {/* Questa rotta sarà protetta */}
          <Route exact path="/register-login" element={<RegisterLoginPage />} />
          <Route exact path="/reset-password" element={<ResetPasswordRequest />} />
          <Route exact path="/set-new-password" element={<SetNewPassword />} />
          <Route exact path="/choose-category" element={<ChooseCategory />} />
          <Route exact path="/shop" element={<Shop />} />
          <Route exact path="/test" element={<Test />} />
          <Route exact path="/company-handle-request/:requestId" element={<CompanyHandleRequest />} />
          <Route exact path="/who-we-are" element={<WhoWeAre />} />
          <Route exact path="/contacts" element={<Contacts />} />
          <Route exact path="/partner" element={<PartnerPage />} />
          <Route exact path="/terms-and-conditions" element={<UserTermsAndConditions />} />
          <Route exact path="/partner-terms-and-conditions" element={<PartnerUserTermsAndConditions />} />
          <Route exact path="/image-disclaimer" element={<ImageDisclaimer />} />
          <Route exact path="/download-app-tutorial" element={<DownloadTutorial />} />

          <Route element={<ProtectedRoute requiredLevel={1} />}>
            <Route exact path="/my-profile" element={<ProfilePage />} />
            <Route exact path="/favourites" element={<FavouritesPage />} />
            <Route exact path="/activity-details" element={<ActivityDetails />} />
            <Route exact path="/activity-gallery" element={<PhotosGallery />} />
            <Route exact path="/all-activities" element={<AllActivities />} />
            <Route exact path="/product-details" element={<ProductDetails />} />
            <Route exact path="/map-page" element={<MapPage />} />
            <Route exact path="/request/success" element={<UserPurchaseResult />} /> {/* Acquisto attività avvenuto (?) */}
            <Route exact path="/product-purchase-success" element={<ProductPurchased />} /> {/* Acquisto in shop avvenuto */}
            <Route exact path="/cart" element={<Cart />} />
            <Route exact path="/checkout" element={<CheckoutPage />} />

            {/* Middleware di check dati per acquisto esperienza */}
            <Route element={<UserPurchaseDataCheck />}>
              <Route exact path="/send-request/:activityId" element={<SendRequest />} />
            </Route>
            <Route exact path="/set-user-data" element={<SetUserData />} />

            {/* Middleware di check dati per acquisto prodotto in shop */}
            <Route element={<UserShippingDataCheck />}>
              <Route exact path="/confirm-order-request" element={<ConfirmOrderRequest />} />
            </Route>
            <Route exact path="/set-shipping-data" element={<SetShippingData />} />
            {/* <Route exact path="/payment-success" /> */}
          </Route>

          <Route element={<ProtectedRoute requiredLevel={2} />}>
            <Route exact path="/handle-activities" element={<HandleActivities />} />
            <Route exact path="/handle-companies" element={<HandleCompanies />} />
            <Route exact path="/add-edit-activity" element={<AddEditActivity />} />
            <Route exact path="/add-edit-company" element={<AddEditCompany />} />
            <Route exact path="/add-edit-product" element={<AddEditProduct />} />
            <Route exact path="/handle-shop" element={<HandleShop />} />
            <Route exact path="/company-details" element={<CompanyDetails />} />
            <Route exact path="/handle-activity-translation" element={<HandleActivityTranslation />} />
          </Route>
        </Routes>
        <Footer />
        <BaseBar />
      </MainContainer>
    </Router>
  );
}

export default App;
